export default "assets/images/noeud-bleu-1d05df5f.png";